export enum SettingsRequisitesComponent {
  main = "main",
  bank = "bank",
  crypto = "crypto",
}
